import { createTheme } from "@material-ui/core/styles";
const themeButton = createTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule

      root: {
        marginBottom: 20,
        fontSize: 12,
        color: "#FFF",
        backgroundColor: "#24232B",
        "&:hover": {
          backgroundColor: "#3F3F3F",
        },
      },
    },
  },
});
const themeInput = createTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiFormControl: {
      // root: {
      "&:focus-visible": {
        borderColor: "#434359",
      },
      // },
    },
    MuiTextField: {
      // Name of the rule
      root: {
        marginLeft: 0,
        backgroundColor: "#24232B",
        // border: "1px solid #e2e2e1",
        borderRadius: 4,
        color: "#FFF",
        margin: 5,
        "&:hover": {
          backgroundColor: "#3F3F3F",
        },
      },
    },
    MuiFormLabel: {
      root: {
        color: "#FFF",
      },
    },

    MuiOutlinedInput: {
      root: {
        color: "#FFF",
      },
    },
    MuiFilledInput: {
      root: {
        color: "#FFF",
      },
    },
  },
});

export default { themeButton, themeInput };
